/**
 * token接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const tokenEndpoints: ApiEndpoint[] = [
  {
    id: "token-list",
    method: "GET",
    path: "/api/services/:id/tokens",
    name: "获取服务Token列表",
    description: "获取指定服务的Token列表",
    category: API_CATEGORIES.TOKEN,
    pathParams: [{ name: "id", type: "string", required: true, description: "服务ID" }],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.tokens", type: "array", description: "Token列表" },
      { name: "data.allowedAudience", type: "array", description: "令牌受众列表" },
      { name: "data.tokens[].id", type: "string", description: "Token ID" },
      { name: "data.tokens[].tokenValue", type: "string", description: "Token值" },
      { name: "data.tokens[].expiresAt", type: "string", description: "过期时间" },
      { name: "data.tokens[].isActive", type: "boolean", description: "是否激活" },
      { name: "data.tokens[].usageCount", type: "number", description: "使用次数" },
      { name: "data.tokens[].maxUsage", type: "number", description: "最大使用次数" },
    ],
    requiredPermission: "msadmin:services:view",
  },
  {
    id: "token-create",
    method: "POST",
    path: "/api/services/:id/tokens",
    name: "创建服务Token",
    description: "为指定服务创建Token",
    category: API_CATEGORIES.TOKEN,
    pathParams: [{ name: "id", type: "string", required: true, description: "服务ID" }],
    bodyParams: [
      { name: "expires_at", type: "string", required: false, description: "过期时间（ISO格式）" },
      { name: "is_active", type: "boolean", required: false, description: "是否激活", example: "true" },
      { name: "max_usage", type: "number", required: false, description: "最大使用次数" },
      { name: "ip_whitelist", type: "string", required: false, description: "IP白名单（逗号分隔）" },
      { name: "description", type: "string", required: false, description: "Token描述" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.token", type: "object", description: "创建的Token信息" },
    ],
    requiredPermission: "msadmin:services:create-token",
    responseExample: JSON.stringify({
      success: true,
      message: "Token创建成功",
      data: {
        token: {
          id: "1",
          token_value: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
          service_name: "msadmin",
          expires_at: "2025-12-31T23:59:59.000Z",
          is_active: true,
          max_usage: 1000,
          ip_whitelist: "192.168.1.1,10.0.0.1",
          description: "API访问Token",
          allowed_audience: ["msspace", "msmq"],
          usage_count: 0,
          created_at: "2025-01-20T10:00:00.000Z",
        },
      },
    }, null, 2),
  },
  {
    id: "token-update",
    method: "PUT",
    path: "/api/services/:serviceId/tokens/:tokenId",
    name: "更新服务Token",
    description: "更新指定服务的Token信息",
    category: API_CATEGORIES.TOKEN,
    pathParams: [
      { name: "serviceId", type: "string", required: true, description: "服务ID" },
      { name: "tokenId", type: "string", required: true, description: "Token ID" },
    ],
    bodyParams: [
      { name: "expires_at", type: "string", required: false, description: "过期时间（ISO格式）" },
      { name: "is_active", type: "boolean", required: false, description: "是否激活" },
      { name: "max_usage", type: "number", required: false, description: "最大使用次数" },
      { name: "ip_whitelist", type: "string", required: false, description: "IP白名单（逗号分隔）" },
      { name: "description", type: "string", required: false, description: "Token描述" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.token", type: "object", description: "更新后的Token信息" },
    ],
    requiredPermission: "msadmin:services:update-token",
  },
  {
    id: "token-delete",
    method: "DELETE",
    path: "/api/services/:serviceId/tokens/:tokenId",
    name: "删除服务Token",
    description: "删除指定服务的Token",
    category: API_CATEGORIES.TOKEN,
    pathParams: [
      { name: "serviceId", type: "string", required: true, description: "服务ID" },
      { name: "tokenId", type: "string", required: true, description: "Token ID" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
    ],
    requiredPermission: "msadmin:services:delete-token",
  },
  {
    id: "token-refresh",
    method: "POST",
    path: "/api/services/:serviceId/tokens/:tokenId/refresh",
    name: "刷新服务Token",
    description: "刷新指定服务的Token（生成新Token）",
    category: API_CATEGORIES.TOKEN,
    pathParams: [
      { name: "serviceId", type: "string", required: true, description: "服务ID" },
      { name: "tokenId", type: "string", required: true, description: "Token ID" },
    ],
    responseFields: [
      { name: "success", type: "boolean", description: "请求是否成功" },
      { name: "message", type: "string", description: "响应消息" },
      { name: "data.token", type: "object", description: "新的Token信息" },
    ],
    requiredPermission: "msadmin:services:update-token",
  },
];
